import { debounce } from 'lodash';
import * as React from 'react';

export function useDebouncedValue<T>(value: T, wait = 500) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initialValue = React.useMemo(() => value, []);
  const [internalValue, setInternalValue] = React.useState(initialValue);

  const debouncedSetState = React.useMemo(() => debounce(setInternalValue, wait), [wait]);

  React.useEffect(() => {
    debouncedSetState(value);
  }, [value, debouncedSetState]);

  return internalValue;
}
